<template>
  <div id="app" class="app">
    <AppHeader id="app-header" />
    <div id="app-body" class="app-body">
      <main class="main">
        <div id="app-content" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter id="app-footer" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter-APP_TARGET'

export default {
  name: 'Full',
  components: { AppHeader, AppFooter },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>
